import React from 'react';

import ContentPageWrapper from '../components/ContentPageWrapper';

const ImprintPage = () => <ContentPageWrapper>Impressum</ContentPageWrapper>;

export default ImprintPage;